(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["contact-form"] && !Shopify.designMode) return;
  try {
    function prefillRentalEnquiry() {
  const equipment = new URLSearchParams(window.location.search).get('geraet');
  if (!equipment) return;
  document.querySelectorAll('[data-xtra-equipment]').forEach((input) => {
    if (!input.value) input.value = equipment.slice(0,250);
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', prefillRentalEnquiry, { once: true });
} else {
  prefillRentalEnquiry();
}
  } catch(e) { console.error(e); }
})();

})();
